import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ImpactBoostAcademyPage from "./pages/ImpactBoostAcademyPage";
import SistemasDeImpactoPage from "./pages/SistemasDeImpactoPage";
import BoostOpsPage from "./pages/BoostOpsPage";
import MovilizacionRecursosPage from "./pages/MovilizacionRecursosPage";
import TechSocialPage from "./pages/TechSocialPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impact-boost-academy" element={<ImpactBoostAcademyPage />} />
          <Route path="/sistemas-de-impacto" element={<SistemasDeImpactoPage />} />
          <Route path="/boost-ops" element={<BoostOpsPage />} />
          <Route path="/academia/movilizacion-recursos" element={<MovilizacionRecursosPage />} />
          <Route path="/academia/tech-social" element={<TechSocialPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
